import React, { useCallback, useEffect, useMemo, useState } from "react";
import { createEditor, Transforms } from "slate";
import { Slate, Editable, withReact, useSlate } from 'slate-react';
import ControlElement from "./elements/control";
import EmojiToolbar from "./toolbar/emoji";
import { withHistory } from "slate-history";
import ControlToolbar from "./toolbar/control";
import withControls from "./plugins/withControls";
import { listControl } from "./constant/constant";
import { randomString } from "../../../../services/helpers/Helper";

const Element = (props) => {
   const { attributes, children, element, value, handleChangeValue, listControl } = props;
   switch (element.type) {
      case 'control':
         return <ControlElement
            {...props}
            value={value}
            onChange={handleChangeValue}
            listControl={listControl} />
      default:
         return <p {...attributes}>{children}</p>
   }
}
const Leaf = ({ attributes, children, leaf }) => {
   return <span {...attributes}>{children}</span>
}

const SlateEditor = ({
   emoji,
   control,
   valueDefault,
   onChange,
   placeholder,
   maxLength,
   configControl,
   onBlur = () => { },
   autoFocus,
   readOnly = false
}) => {

   const [isShowEmoji, setIsShowEmoji] = useState(false);
   const [isShowControl, setIsShowControl] = useState(false);
   const [isFocus, setIsFocus] = useState(false);
   const [value, setValue] = useState([
      {
         type: 'paragaph',
         children: [{ text: '' }],
      },
   ]);
   const fiControl = configControl ? configControl : listControl;

   const getLengthText = (value) => {
      let length = 0
      value.forEach(item => {
         item.children.forEach(child => {
            // Nếu có text trong children, thêm vào đoạn văn bản
            if (child.text) {
               length += child.text.length;
            }
         });
         // Thêm dấu xuống dòng sau mỗi phần tử, trừ phần tử cuối cùng
         if (item !== value[value.length - 1]) {
            length += 1;
         }
      });
      return length;
   }

   const withCharacterLimit = (editor) => {
      const { insertText } = editor;

      editor.insertText = (text) => {
         const { selection } = editor;
         const { anchor } = selection;
         if (text && maxLength && text.length + getLengthText(editor.children) > maxLength) {
            return;
         }
         insertText(text);
      };

      return editor;
   };

   const editor = useMemo(() => withCharacterLimit(withHistory(withControls(withReact(createEditor())))), []);

   const renderElement = useCallback(props => <Element {...props} value={value} handleChangeValue={handleChangeValue} listControl={fiControl} />, [value])
   const renderLeaf = useCallback(props => {
      return <Leaf {...props} />
   }, []);

   const getParts = (str) => {
      const regex = new RegExp(fiControl.map(r => r.code).join('|'), 'g');
      let parts = str.split(regex);
      let index = 0;
      const result = [];
      str.replace(regex, match => {
         result.push(parts[index++]);
         result.push(match);
      });
      result.push(parts[index]);
      return result;
   }

   useEffect(() => {
      if (valueDefault) {
         const json = [];
         // Tách văn bản thành các đoạn
         const paragraphs = valueDefault.split('\\n');
         paragraphs.forEach((paragraph) => {
            const obj = { type: 'paragraph', children: [] };
            // const parts = paragraph.split(/({{.*?}})/);
            const parts = getParts(paragraph);
            parts.forEach((part) => {
               const fi = fiControl.find((item) => item.code == part);
               if (fi) {
                  obj.children.push({ type: 'control', code: fi.code, id: randomString(), children: [{ text: fi.name }] });
               } else {
                  obj.children.push({ text: part });
               }
            });

            json.push(obj);
         });
         setValue(json);
      }
   }, [valueDefault]);

   const handleChangeValue = (newValue) => {
      let text = '';
      newValue.forEach(item => {
         // Lặp qua từng children trong mỗi phần tử
         item.children.forEach(child => {
            if (child.type === 'control') {
               // Nếu có type là control, thêm vào đoạn văn bản
               text += `${child.code}`;
            }
            // Nếu có text trong children, thêm vào đoạn văn bản
            if (child.text) {
               text += child.text;
            }
         });
         // Thêm dấu xuống dòng sau mỗi phần tử, trừ phần tử cuối cùng
         if (item !== newValue[newValue.length - 1]) {
            text += '\n';
         }
      });
      if (onChange) {
         onChange(text);
      }
      setValue(newValue);
   }
   const [showEditor, setShowEditor] = useState(false);

   useEffect(() => {
      // Sử dụng setTimeout để trì hoãn hiển thị component
      const timer = setTimeout(() => {
         setShowEditor(true);
      }, 100); // Điều chỉnh thời gian nếu cần thiết
      // Hủy bỏ timeout khi component unmount
      return () => clearTimeout(timer);
   }, []);

   return (
      <React.Fragment>
         <div className='editor-slate'>
            {showEditor && (
               <Slate editor={editor} value={value} onChange={handleChangeValue} >
                  <div className="editor-wrapper" style={{ padding: '0 10px' }}>
                     <Editable
                        readOnly={readOnly}
                        placeholder={placeholder}
                        renderElement={renderElement}
                        renderLeaf={renderLeaf}
                        onBlur={() => {
                           setTimeout(() => {
                              setIsShowEmoji((old) => {
                                 if (!old) onBlur();
                                 return old;
                              });
                           }, 100);
                           setIsFocus(false);
                        }}
                        onFocus={() => setIsFocus(true)}
                        autoFocus={autoFocus}
                        onKeyDown={event => {
                           if (event.key === 'Enter') {
                              event.preventDefault();
                              // Lưu trữ vị trí con trỏ hiện tại
                              const { selection } = editor;
                              // Chèn một dòng mới
                              Transforms.insertText(editor, '\n');
                              // Khôi phục vị trí con trỏ
                              Transforms.select(editor, {
                                 anchor: { path: selection.anchor.path, offset: selection.anchor.offset + 1 },
                                 focus: { path: selection.focus.path, offset: selection.focus.offset + 1 }
                              });
                           }
                        }}
                     />
                  </div>
                  <div className="input-text-plugins text-no-bold focus-thin hover-slate" style={{ display: (isShowEmoji || isShowControl) ? 'block' : '' }}>
                     <div>
                        {emoji && <EmojiToolbar
                           isShow={isShowEmoji}
                           setIsShow={setIsShowEmoji}
                           getLengthText={getLengthText}
                           maxLength={maxLength}
                           onBlur={onBlur}
                           isFocus={isFocus}
                        />}
                        {control && <ControlToolbar
                           isShow={isShowControl}
                           setIsShow={setIsShowControl}
                           listControl={fiControl}
                        />}
                        {maxLength && <div className="plugins-controls plugins-controls-counter">
                           <span className="text-smallest">{maxLength - getLengthText(value)}</span>
                        </div>}
                     </div>
                  </div>
               </Slate>
            )}
         </div>

      </React.Fragment>
   )
}

export default SlateEditor;
